import { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { selectApplication, selectLimitDamagePremRented, selectPolicyTypes } from '../selectors/application';
import { Container } from '../elements';
import { PolicyType } from '../types/enums';
import PolicySummaryCards from '../Components/Summary/Policies';
import { MobileAndTablet } from '../helpers/responsive';
import InfoSidebar from '../Components/Shared/InfoSidebar';
import SmoothCollapse from 'react-smooth-collapse';
import { getAvailableEndorsements } from '../selectors/availableEndorsements';
import BusinessSummary from '../Components/Summary/Business/BusinessSummary';
import AddOnsSummary from '../Components/Summary/AddOns/AddOnsSummary';

interface PropTypes {
  application: Application;
  selectedPolicies: PolicyType[];
  hasAvailableEndorsements: boolean;
  limitDamagePremRented?: number;
}

class Summary extends Component<PropTypes> {
  componentDidMount() {
    document.title = 'Coterie - My Policy Summary';
    window.scrollTo(0, 0);
  }

  render() {
    const { application, selectedPolicies, hasAvailableEndorsements, limitDamagePremRented } = this.props;

    const shouldShowPackages = selectedPolicies?.includes(PolicyType.BOP);
    const hasBOPorGL = selectedPolicies?.includes(PolicyType.BOP) || selectedPolicies?.includes(PolicyType.GL);

    return (
      <SummaryContainer data-cy="summary-page">
        <InnerContainer>
          <MobileAndTablet>
            <InfoSidebar />
          </MobileAndTablet>
          <BusinessSummary application={application} />
          <PolicySummaryCards />
        </InnerContainer>

        <SmoothCollapse
          expanded={hasAvailableEndorsements || shouldShowPackages || hasBOPorGL || Boolean(limitDamagePremRented)}
          allowOverflowWhenOpen
        >
          <AddOnsSummary shouldShowPackages={shouldShowPackages} hasBOPorGL={hasBOPorGL} />
        </SmoothCollapse>
      </SummaryContainer>
    );
  }
}

const mapStateToProps = (state: ReduxState) => ({
  application: selectApplication(state),
  selectedPolicies: selectPolicyTypes(state),
  hasAvailableEndorsements: Boolean(getAvailableEndorsements(state)),
  limitDamagePremRented: selectLimitDamagePremRented(state),
});

const InnerContainer = styled.div`
  width: 100%;
  align-self: center;
  @media (max-width: 767px) {
    max-width: 100%;
  }
`;

const SummaryContainer = styled(Container)`
  padding: 0 24px;
  width: 100%;
  max-width: 664px;

  .react-datepicker-wrapper {
    width: 100%;
  }

  .date-picker-container {
    margin-bottom: 0;
  }
`;

export default connect(mapStateToProps)(Summary);
